import React, {Component} from 'react';
import {Checkbox, Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import moment from "moment";
import $ from 'jquery'


export default class WynajemContainer extends Component {

    constructor(props) {
        super(props);

        if (localStorage.getItem('EBUS_EdycjaWynajem') !== null) {
            let pojazd = this.props.pojazd
            if (this.props.pojazd === null || this.props.pojazd === undefined){
                pojazd = null;
            }
            this.state = {
                miejsceOd: this.props.data.miejsceOd,
                miejsceDo: this.props.data.miejsceDo,
                dataOd: moment(this.props.data.dataOd),
                dataDo: moment(this.props.data.dataDo),
                godzinaOd: moment(this.props.data.dataOd).format("HH:mm").toString(),
                godzinaDo: moment(this.props.data.dataDo).format("HH:mm").toString(),
                tytul: this.props.data.tytul,
                kierowca: this.props.kierowca,
                kierowcy: this.props.kierowcy,
                status: this.props.data.status,
                statusy: [{value: 1, label: 'ZAPYTANIE'}, {value: 2, label: 'REZERWACJA'}, {value: 3, label: 'ZAMÓWIENIE'}, {
                    value: 4,
                    label: 'WYKONANY'
                }],
                samochod: pojazd,
                samochody: this.props.pojazdy,
                liczbaPasazerow: this.props.data.ileOsob,
                vatNiemiecki: this.props.data.vatNiemiecki
            };
        } else {
            this.state = {
                miejsceOd: '',
                miejsceDo: '',
                dataOd: '',
                dataDo: '',
                godzinaOd: '00:00',
                godzinaDo: '23:59',
                tytul: '',
                kierowca: '',
                kierowcy: this.props.kierowcy,
                status: '',
                statusy: [{value: 1, label: 'ZAPYTANIE'}, {value: 2, label: 'REZERWACJA'}, {value: 3, label: 'ZAMÓWIENIE'}, {
                    value: 4,
                    label: 'WYKONANY'
                }],
                samochod: '',
                samochody: this.props.pojazdy,
                liczbaPasazerow: '',
                vatNiemiecki: false
            };
        }

        this.onChangeMiejsceOd = this.onChangeMiejsceOd.bind(this);
        this.onChangeMiejsceDo = this.onChangeMiejsceDo.bind(this);
        this.onChangeTytul = this.onChangeTytul.bind(this);
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeGodzinaOd = this.onChangeGodzinaOd.bind(this)
        this.onChangeGodzinaDo = this.onChangeGodzinaDo.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeSamochod = this.onChangeSamochod.bind(this)
        this.onChangeLiczbaPasazerow = this.onChangeLiczbaPasazerow.bind(this)
        this.onChangeVatNiemiecki = this.onChangeVatNiemiecki.bind(this)
    }

    componentDidMount(){
        $(document).on("wheel", "input[type=time]", function (e) {
            $(this).blur();
        });
    }

    onChangeMiejsceOd(e) {
        this.setState({miejsceOd: e.target.value})
        this.props.setMiejsceOd(e.target.value)
    }

    onChangeMiejsceDo(e) {
        this.setState({miejsceDo: e.target.value})
        this.props.setMiejsceDo(e.target.value)
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
        this.props.setDataOd(e.format("YYYY-MM-DD"))
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
        this.props.setDataDo(e.format("YYYY-MM-DD"))
    }

    onChangeGodzinaOd(e) {
        this.setState({godzinaOd: e.target.value})
        this.props.setGodzinaOd(e.target.value)
    }

    onChangeGodzinaDo(e) {
        this.setState({godzinaDo: e.target.value})
        this.props.setGodzinaDo(e.target.value)
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
        this.props.setKierowca(e)
    }

    onChangeStatus(e) {
        this.setState({status: e})
        this.props.setStatus(e.value)
    }

    onChangeTytul(e) {
        this.setState({tytul: e.target.value})
        this.props.setTytul(e.target.value)
    }

    onChangeSamochod(e) {
        this.setState({samochod: e})
        this.props.setSamochod(e.value)
    }

    onChangeLiczbaPasazerow(e) {
        this.setState({liczbaPasazerow: e.target.value})
        this.props.setLiczbaPasazerow(e.target.value)
    }

    onChangeVatNiemiecki() {
        this.props.setVatNiemiecki(!this.state.vatNiemiecki)
        this.setState({vatNiemiecki: !this.state.vatNiemiecki})
    }

    render() {
        return (
            <Col sm={6}>
                <fieldset>
                    <div className={'fieldset-label'}>Dane wynajmu</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Tytuł:</ControlLabel>
                                <input className="form-control" maxLength={100} onChange={this.onChangeTytul}
                                       value={this.state.tytul}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Miejsce od: <span className={'req'}>*</span></ControlLabel>
                                <input className="form-control" maxLength={60} onChange={this.onChangeMiejsceOd}
                                       value={this.state.miejsceOd}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Miejsce do: <span className={'req'}>*</span></ControlLabel>
                                <input className="form-control" maxLength={60} onChange={this.onChangeMiejsceDo}
                                       value={this.state.miejsceDo}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Data od: <span className={'req'}>*</span></ControlLabel>
                                <TopInputDate onChange={this.onChangeDataOd}
                                              value={this.state.dataOd}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Godzina od: <span className={'req'}>*</span></ControlLabel>
                                <input type="time" className="form-control" onChange={this.onChangeGodzinaOd}
                                       value={this.state.godzinaOd}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Data do: <span className={'req'}>*</span></ControlLabel>
                                <TopInputDate onChange={this.onChangeDataDo}
                                              value={this.state.dataDo}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Godzina do: <span className={'req'}>*</span></ControlLabel>
                                <input type="time" className="form-control" onChange={this.onChangeGodzinaDo}
                                       value={this.state.godzinaDo}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Status:</ControlLabel>
                                <TopSelect onChange={this.onChangeStatus} value={this.state.status}
                                           options={this.state.statusy}
                                           clearable={false}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Samochód:</ControlLabel>
                                <TopSelect onChange={this.onChangeSamochod}
                                           value={this.state.samochod}
                                           options={this.state.samochody}
                                           clearable={false}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Kierowca:</ControlLabel>
                                <TopSelect onChange={this.onChangeKierowca}
                                           value={this.state.kierowca}
                                           options={this.state.kierowcy}
                                           clearable={false}
                                           multi/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Liczba pasażerów: <span className={'req'}>*</span></ControlLabel>
                                <input type="number" className="form-control" min={1}
                                       value={this.state.liczbaPasazerow}
                                       onChange={this.onChangeLiczbaPasazerow}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>VAT Niemiecki:</ControlLabel>
                                <Checkbox style={{marginLeft: 5}}
                                          onChange={this.onChangeVatNiemiecki}
                                          checked={this.state.vatNiemiecki}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                        </FormGroup>
                    </Form>
                </fieldset>
            </Col>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/components/DaneWynajmu.js